<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Settlement Ledgers</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4">
        <div class="d-flex justify-content-end">
          <div class="mb-3">
            <app-date-filter [fromDate]="selectedFromDate" [toDate]="selectedToDate"
              (dateSelected)="onDateSelected($event)">
            </app-date-filter>
          </div>
          @if (selectedFromDate && selectedToDate && count > 0) {
            <div class="mt-1 me-3">
              <button class="btn btn-warning btn-sm" (click)="onDownloadExcel()">
                <i class="bi bi-download me-1"></i> Download Excel
              </button>
            </div>
          }
        </div>
      </div>

      <div class="col-md-12 mb-5">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs ms-2 me-2">
          <li [ngbNavItem]="1">
            <button ngbNavLink>All</button>
            <ng-template ngbNavContent>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <button ngbNavLink>From HNB (Alt-Pay Account)</button>
            <ng-template ngbNavContent>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <button ngbNavLink>To Andaria (Alt-Pay Account)</button>
            <ng-template ngbNavContent>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="4">
            <button ngbNavLink>Commission</button>
            <ng-template ngbNavContent>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</div>